$component-class: 'sn-related-links-type-2';

.#{$component-class} {
  display: block;
  width: 100%;
  background-color: $background-color-primary;

  &__container {
    // Match the signnow me-container width (the sn theme caps .me-container at
    // $sn-container-max-width) so this lines up with sn-related-links-type-1,
    // which renders via me-section/me-container. $media-desktop (1440) was too wide.
    max-width: $sn-container-max-width;
    margin: 0 auto;

    // Horizontal padding matches me-container (var(--spacing-md)); vertical
    // rhythm is kept as designed.
    padding: 0 var(--spacing-md) $spacing-5xl;

    @include desktop {
      padding: 0 var(--spacing-md) $spacing-6xl;
    }

    @include desktop-lg {
      padding-top: 0;
      padding-bottom: $spacing-7xl;
    }
  }

  me-heading {
    display: block;
    margin-bottom: $spacing-3xl;
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: $spacing-md $spacing-3xl;
    list-style: none;
    margin: 0;
    padding: 0;

    @include below-desktop {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (width <= 600px) {
      grid-template-columns: 1fr;
    }
  }

  &__list-item {
    margin: 0;
    padding: 0;
    min-width: 0;
    overflow: hidden;
  }

  &__link {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    text-decoration: none;
    overflow: hidden;
    color: $color-brand-primary-main;
    transition: color 0.2s ease;

    // A single-line link is a 22px tap target, under the 24px minimum Lighthouse checks for.
    min-height: 24px;

    &:hover {
      color: $color-brand-primary-dark;
    }
  }

  &__link-icon {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    flex-shrink: 0;
    color: $color-neutral-black;

    svg {
      fill: $color-neutral-black;
    }
  }

  &__link-text {
    font-weight: 700;
  }
}
